import { useSelector } from 'react-redux';
import useArticleLogsActions from './_actions';

export const useArticleLogs = () => {
    const {
        fetchArticleLogsList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate,
    } = useArticleLogsActions();

    const logs = useSelector(state => state.articlelogs.data);
    const currentPage = useSelector(state => state.articlelogs.currentPage);
    const totalRows = useSelector(state => state.articlelogs.totalRows);
    const rowsPerPage = useSelector(state => state.articlelogs.rowsPerPage);
    const isLoading = useSelector(state => state.articlelogs.isLoading);
    const isError = useSelector(state => state.articlelogs.isError);
    const errorMessage = useSelector(state => state.articlelogs.errorMessage);
    const searchTerm = useSelector(state => state.articlelogs.searchTerm);
    const userType = useSelector(state => state.articlelogs.userType);
    const start_date = useSelector(state => state.articlelogs.start_date);
    const end_date = useSelector(state => state.articlelogs.end_date);
    
    return {
        logs,
        currentPage,
        totalRows,
        rowsPerPage,
        isLoading,
        isError,
        errorMessage,
        searchTerm,
        userType,
        start_date,
        end_date,

        fetchArticleLogsList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate
    }
}

export { default as articleLogsReducer } from './_reducers';